export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Plan Type\",\n    \"label_other\": \"{{count}} Plan Types\"\n}\n"